import { NavigationItem, PermissionName } from '@tripointe/tripointe-cms/types';

export const NAVIGATION_ITEMS: NavigationItem[] = [
  { icon: 'reports', title: 'Reports', url: PermissionName.reports },
  { icon: 'divisions', title: 'Divisions', url: PermissionName.divisions },
  { icon: 'communities', title: 'Communities', url: PermissionName.communities },
  { icon: 'plans', title: 'Plans', url: PermissionName.plans },
  { icon: 'homes', title: 'Homes', url: PermissionName.homes },
  { icon: 'phases', title: 'Phases', url: PermissionName.phases },
  { icon: 'documents', title: 'Documents', url: PermissionName.documents },
  { icon: 'schedule', title: 'Schedule', url: PermissionName.schedule },
  { icon: 'contacts', title: 'Contacts', url: PermissionName.contacts },
  { icon: 'messages', title: 'Messages', url: PermissionName.messages },
  { icon: 'users', title: 'Users', url: PermissionName.users }
];
